export interface TfHullEvaluationVessel {
  imo: string;
  vesselName: string;
  vesselEmail: string | null;
  deskEmail: string | null;
  design: string;
  hasEmailInImos: boolean;
  techFormStatus: string;
  techFormDate: string | null;
  znLink: string | null;
  hullAssessmentCheck: string | null;
  submitHullAssessmentLink: string | null;
  latestManualReminder: string | null;
  opsLink: string | null;
  deliveredSinceDays: number | null;
  enteredSinceDays: number | null;
  deliveryDate: string | null;
  status: string;
  contractType: string;
  contract: string | null;
  minRedeliveryDate: string | null;
  maxRedeliveryDate: string | null;
  entryDate: string | null;
  vesselType: string;
  comment: string | null;
}

export interface TfHullEvaluationsResponse {
  vessels: TfHullEvaluationVessel[];
  totalCount: number;
  lastRefreshedAt: string;
}

export interface TfHullEvaluationsTokenIdentity {
  email?: string;
  sub?: string;
}

export interface TfHullEvaluationFilters {
  imo: string;
  vesselName: string;
  contractTypes: string[];
  statuses: string[];
  vesselType: string;
  deliveredFrom: string;
  deliveredTo: string;
  enteredFrom: string;
  enteredTo: string;
  manualReminder: string;
  hullAssessment: string;
  techFormStatus: string;
  hasEmail: string[];
}

export type TfHullEvaluationAction = "request" | "reminder";

export const EMPTY_TF_HULL_FILTERS: TfHullEvaluationFilters = {
  imo: "",
  vesselName: "",
  contractTypes: [],
  statuses: [],
  vesselType: "",
  deliveredFrom: "",
  deliveredTo: "",
  enteredFrom: "",
  enteredTo: "",
  manualReminder: "",
  hullAssessment: "",
  techFormStatus: "",
  hasEmail: [],
};

export const TF_HULL_ALLOWED_EMAILS = [
  "adrian_moisa@crgl-thirdparty.com",
  "guilhem_servet@cargill.com",
] as const;

export const TF_HULL_MOCK_STORAGE_KEY = "tfHullEvaluationsMockEnabled";
export const TF_HULL_MOCK_EVENT = "tf-hull-evaluations-mock-change";

function isTfHullAllowedEmail(value: string | undefined): boolean {
  const normalizedEmail = value?.trim().toLowerCase();

  return TF_HULL_ALLOWED_EMAILS.some((allowedEmail) => allowedEmail === normalizedEmail);
}

// Accepts both common identity claims because the provider can place the email in either one.
export function canViewTfHullEvaluations(token: TfHullEvaluationsTokenIdentity | null | undefined): boolean {
  return isTfHullAllowedEmail(token?.email) || isTfHullAllowedEmail(token?.sub);
}
